module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-07-deb557820854fd02a21e152aabbe6393.jpg";